
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/subscriptions/[slug]",
      function () {
        return require("private-next-pages/shop/subscriptions/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/subscriptions/[slug]"])
      });
    }
  